/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import borders from "assets/theme/base/borders";
import { figmaTokens } from "assets/theme/designTokens";

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderWidth } = borders;

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      borderBottom: `${borderWidth[1]} solid ${figmaTokens.borderSubtle}`,
      fontSize: pxToRem(14),
      color: figmaTokens.textBody,
      "&.MuiTableCell-head": {
        backgroundColor: figmaTokens.tableHeaderBg,
        color: figmaTokens.tableHeaderText,
        fontSize: pxToRem(12),
        fontWeight: 600,
        letterSpacing: "0.6px",
        textTransform: "uppercase",
        borderBottom: `1px solid ${figmaTokens.borderSubtle}`,
      },
    },
  },
};

export default tableCell;
